"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    bytecloudJwtService: ()=>bytecloudJwtService
});
const core_lib_namespaceObject = require("@bytecloud/core-lib");
const external_jwt_config_js_namespaceObject = require("./jwt.config.js");
const external_jwt_init_util_js_namespaceObject = require("./jwt-init-util.js");
const cacheObject = (0, external_jwt_init_util_js_namespaceObject.initJwtPromiseCache)();
const bytecloudJwtService = new core_lib_namespaceObject.PackagedJwtService({
    items: external_jwt_config_js_namespaceObject.jwtItems,
    storageGet: external_jwt_init_util_js_namespaceObject.storageGet,
    storageSet: external_jwt_init_util_js_namespaceObject.storageSet,
    promiseCacheObject: cacheObject
});
exports.bytecloudJwtService = __webpack_exports__.bytecloudJwtService;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "bytecloudJwtService"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
